import { Checkbox } from 'antd'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FunctionComponent } from 'react'
import styled, {
  css,
  DefaultTheme,
  FlattenInterpolation,
  ThemeProps,
} from 'styled-components'
import { RankType } from '@/api/workspaces-api'

interface SorterProps {
  hasKolBusinessType: boolean
  onKolBusinessTypeChange: (hasKolBusinessType: boolean) => void
  rankType:
    | RankType.ViewRate
    | RankType.WordOfMouthVolume
    | RankType.EngagementRate
}

const Sorter: FunctionComponent<SorterProps> = ({
  hasKolBusinessType,
  onKolBusinessTypeChange,
  rankType,
}) => {
  const router = useRouter()
  const getLink = (targetRankType: string): string => {
    const fromRankType = ((): string => {
      switch (rankType) {
        case RankType.WordOfMouthVolume:
          return 'community-volume'
        case RankType.EngagementRate:
          return 'growth-rate'
        case RankType.ViewRate:
          return 'view-rate'
      }
    })()
    return router.asPath.replace(fromRankType, targetRankType)
  }

  return (
    <Wrapper>
      <Options>
        <Link href={getLink('community-volume')}>
          <Option active={rankType === RankType.WordOfMouthVolume}>
            <DesktopOnlyText>依</DesktopOnlyText>
            口碑聲量排序
          </Option>
        </Link>
        <Link href={getLink('growth-rate')}>
          <Option active={rankType === RankType.EngagementRate}>
            <DesktopOnlyText>依</DesktopOnlyText>
            互動率排序
          </Option>
        </Link>
        <Link href={getLink('view-rate')}>
          <Option active={rankType === RankType.ViewRate}>
            <DesktopOnlyText>依</DesktopOnlyText>
            觀看率排序
          </Option>
        </Link>
      </Options>
      <div>
        <span>排除：</span>
        <Checkbox
          checked={hasKolBusinessType}
          onChange={(e): void => onKolBusinessTypeChange(e.target.checked)}
        >
          官方帳號
        </Checkbox>
      </div>
    </Wrapper>
  )
}

const Option = styled.span<{ active: boolean }>`
  padding: 12px 20px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 700;

  ${({ active, theme }): FlattenInterpolation<ThemeProps<DefaultTheme>> =>
    active
      ? css`
          color: ${theme.colors.text.white};
          background-color: ${theme.colors.brand.primary};
        `
      : css`
          cursor: pointer;
          color: ${theme.colors.text.secondary};
          background-color: ${theme.colors.background.white};
        `};

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 12px 16px;
  }
`
const Options = styled.div`
  display: flex;
`

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 16px;
  background-color: ${({ theme }): string => theme.colors.background.white};
  max-width: 1140px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    ${Options} {
      margin-bottom: 20px;
    }
  }
`

const DesktopOnlyText = styled.span`
  @media ${({ theme }): string => theme.rwd['mobile-query']} {
    display: none;
  }
`

export default Sorter
